import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useSession } from '../App';

const MerchantSelect = () => {
    const navigate = useNavigate();
    const { logout } = useSession();

    const merchants = [
        { id: 'madeluxe', name: 'Madeluxe', description: 'Fashion and accessories merchant' },
        { id: 'pawesome', name: 'Pawesome', description: 'Pet supplies and accessories merchant' }
    ];

    const handleMerchantSelect = (merchantId) => {
        navigate(`/private/${merchantId}`);
    };

    const handleLogout = () => {
        // Clear auth tokens
        localStorage.removeItem('authToken');
        localStorage.removeItem('userType');
        localStorage.removeItem('username');

        // Close session
        logout();
        // Redirect to login page
        navigate('/index');
    };

    return (
        <Container className="py-5">
            <Row className="mb-4">
                <Col className="d-flex justify-content-between align-items-center">
                    <div>
                        <h2 className="mb-2">Select Merchant</h2>
                        <p className="text-muted mb-0">Choose a merchant to manage their MELI integration</p>
                    </div>
                    <Button
                        variant="outline-danger"
                        onClick={handleLogout}
                        size="sm"
                    >
                        Logout
                    </Button>
                </Col>
            </Row>

            <Row className="justify-content-center">
                {merchants.map((merchant) => (
                    <Col key={merchant.id} md={6} lg={4} className="mb-4">
                        <Card className="h-100 shadow-sm merchant-card">
                            <Card.Body className="d-flex flex-column text-center p-4">
                                <div className="mb-3">
                                    <h4 className="text-primary">{merchant.name}</h4>
                                    <p className="text-muted">{merchant.description}</p>
                                </div>

                                <Button
                                    variant="outline-primary"
                                    size="lg"
                                    onClick={() => handleMerchantSelect(merchant.id)}
                                    className="mt-auto"
                                >
                                    Select {merchant.name}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default MerchantSelect;
